// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const LIST_OF_FORUMS = "Seznam f\u00f3r";
export const NEWEST_DISCUSSIONS = "Nejnov\u011bj\u0161\u00ed diskuze";
export const SHORTENED_SEARCH_IN_FORUM = "Hledej v diskuz\u00edch...";
export const WHERE_ARE_DISCUSSIONS = "Kde se pr\u00e1v\u011b diskutuje";
